<template>
  <div class="layout-bd ub">
    <div class="layout-aside">
      <t-menu :appId="appId" :appMenu="appMenu" :appList="appList" :hideside="hideSide" @change="onChangeApp"></t-menu>
    </div>
    <div class="layout-section ub-f1 ubv ub-f0h">
      <t-header></t-header>
      <t-tags :tags="tags" @change="onChangeTag"></t-tags>
      <div class="layout-content ub-f1 ubv ub-f0w">
        <div class="app-content">
          <keep-alive :include="includeList">
            <router-view />
          </keep-alive>
        </div>
      </div>
    </div>
    <!--修改密码 -->
    <usersetResetPassword :model="dialogModel" v-if="visible" @close="visible = false"></usersetResetPassword>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import usersetResetPassword from '@/pages/base/components/resetPwdDialog.vue';
import { mapState } from 'vuex';
import apis from '@/utils/apis';
import tMenu from './menu.vue';
import tHeader from './header.vue';
import tTags from './tags.vue';

export default {
  components: { tMenu, tHeader, tTags, usersetResetPassword },
  name: 'layout',
  data() {
    return {
      appList: [], // 应用列表
      appMenu: [], // 菜单列表
      visible: false,
      dialogModel: {},
    };
  },
  computed: {
    ...mapState({
      tags: (state) => state.vm.tags,
      hideSide: (state) => state.vm.hideSide,
      includeList: (state) => state.vm.includeList,
    }),
    // 当前应用Id
    appId: {
      get() {
        return this.$store.state.appId;
      },
      set(val) {
        this.$store.commit('APP_ID', val);
      },
    },
  },
  mounted: function () {
    this.initApp();
    this.getAppLanguage();
    this.onPswdLoginChange();
    this.Bus.$on('initMenu', (path) => {
      this.initMenuPath(path);
    });
  },
  methods: {
    // 获取应用多语言(菜单多语言+组件多语言)
    getAppLanguage() {
      const langCode = Cookies.get('langCode') || 'CN';
      this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'isynergy_cloud' }).then((res) => {
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
      this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'bas' }).then((res) => {
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
      this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'dms' }).then((res) => {
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
      this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'crm' }).then((res) => {
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
      this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'asm' }).then((res) => {
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
      this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'fms' }).then((res) => {
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
      this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'training' }).then((res) => {
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
      this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'sta' }).then((res) => {
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
    },
    onPswdLoginChange() {
      const isShow = this.$store.state.pswdLoginChange;
      if (isShow === '1') {
        this.dialogModel.title = this.$t('components_layout.xiu_gai_mi_ma');
        this.dialogModel.type = 'window';
        this.visible = true;
      }
    },
    initMenu: function () {
      this.$getJSON(apis.MenuItem, {
        loadRes: this.$route.query.parent || this.$route.path,
      }).then((res) => {
        this.appId = res.data.appId || this.appList[0]['appId'];
        this.initAppMenu();
      });
    },
    initMenuPath: function (path) {
      this.$getJSON(apis.MenuItem, {
        loadRes: path.replace('/redirect', ''),
      }).then((res) => {
        this.appId = res.data.appId || this.appList[0]['appId'];
        this.initAppMenu();
      });
    },
    // 初始化应用
    initApp: async function () {
      const [app, current] = await Promise.all([
        this.$getJSON(apis.AppList, { appType: 2 }),
        this.$getJSON(apis.MenuItem, {
          loadRes: this.$route.query.parent || this.$route.path,
        }),
      ]);
      this.appList = app.data;
      this.appId = current.data.appId || this.appList[0]['appId'];
      this.initAppMenu();
    },
    // 初始化菜单
    initAppMenu: async function (cb) {
      cb = cb || function () {};
      this.$getJSON(`${apis.App}/${this.appId}`).then((res) => {
        this.appMenu = res.data || [];
        cb();
      });
    },
    // 切换应用
    onChangeApp: function (item) {
      this.appId = item.appId;
      this.initAppMenu(() => {
        const firstMenu = this.appMenu[0] || {};
        const firstMenuItem = firstMenu.children && firstMenu.children[0] ? firstMenu.children[0] : firstMenu;
        this.jump(firstMenuItem.loadRes);
      });
    },
    // 切换标签
    onChangeTag: function (tag) {
      if (this.appId !== tag.appId) {
        this.appId = tag.appId || this.appList[0]['appId'];
        this.initAppMenu(() => {
          // this.translateTags();
        });
      }
    },
    // 页面标签转换(多语言)
    // translateTags: function () {
    //   const tags = this.$store.state.vm.tags;
    //   const menuList = this.$treeTransArray(
    //     [...this.appMenu, ...this.sysMenu],
    //     'children'
    //   );
    //   tags.forEach((item) => {
    //     const current = menuList.find(t => t.loadRes === item.loadRes);
    //     if (current) {
    //       item.menuName = current.menuName;
    //       item.fullPathName = current.fullPathName;
    //       if (item.childPathName) {
    //         const child = menuList.find(t => t.loadRes === item.childRes) || {};
    //         item.childPathName = child.fullPathName;
    //       }
    //     }
    //   });
    // }
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.layout-bd {
  height: 100%;
  .layout-content {
    overflow-y: auto;
  }
  .app-content {
    flex: 1;
    height: 0;
    position: relative;

    // 包含（搜索栏，表格等）内容
    & > .bd {
      height: 100%;
      padding: 16px;
      position: relative;
      //  左右结构
      & > .aside {
        position: absolute;
        box-shadow: 0.5px 0px 3px 0px rgba(51, 51, 51, 0.12);
        top: 0;
        left: 0;
        bottom: 0;
        width: 240px;
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;
        background-color: #ffffff;
        overflow: auto;
        .title {
          padding: 0 10px;
          line-height: 70px;
          color: #394668;
          font-weight: bold;
          font-size: 15px;
          .icon {
            float: left;
            font-size: 14px;
            margin-right: 8px;
            font-weight: normal;
            @include color_main();
          }
        }
        .search {
          margin: 0 10px 16px;
        }
        .list {
          .el-tree-node__content > .el-tree-node__expand-icon {
            display: none;
          }
          .el-tree-node__content .tree-item {
            padding-left: 10px;
          }
        }
        .list,
        .tree {
          flex: 1;
          margin: 0 10px;
          overflow-y: auto;
          .el-tree-node__content {
            line-height: 32px;
            height: 32px;
            &:hover {
              background-color: #f8f9fb;
            }
          }
          .el-tree-node__content > .el-tree-node__expand-icon {
            color: #495057;
            &.is-leaf {
              color: transparent;
            }
          }
          .is-current > .el-tree-node__content {
            background-color: #eef2f8 !important;
            .tree-item {
              @include color_main();
              .icon {
                @include color_main();
                font-size: 12px;
              }
              .disable {
                color: rgba(108, 117, 125, 0.5);
              }
            }
          }
          .tree-item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            padding-right: 10px;
            overflow: hidden;
            color: #6c757d;
            .disable {
              color: rgba(108, 117, 125, 0.5);
            }
          }
        }
      }
      & > .section {
        height: 100%;
        margin-left: 240px;
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        padding: 0 16px;
        &.padding0 {
          padding: 0;
        }
        .section-info {
          padding-top: 16px;
          table {
            width: 100%;
          }
          table tr {
            height: 44px;
            line-height: 44px;
            text-align: left;
            th {
              padding: 0 10px;
              font-size: 12px;
              color: #636e78;
              background-color: #f2f3fb;
            }
            td {
              padding: 0 10px;
              color: #6c757d;
              font-size: 12px;
              border-bottom: 1px solid #eef2f8;
            }
          }
        }
        .table-bd {
          flex: 1;
          height: 0;
        }
      }
    }
    // 只包含表格
    & > .tb {
      height: calc(100% - 32px);
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 0 16px;
      margin: 16px;
      background-color: #ffffff;
    }
    // 内联步骤页
    & > .flow {
      height: 100%;
      position: relative;
      overflow: auto;
      .aside {
        position: absolute;
        left: 0;
        top: 0;
        width: 220px;
        bottom: 0;
        background-color: #f9f9fd;
        .title {
          color: #394668;
          font-size: 14px;
          height: 70px;
          font-weight: bold;
          padding-left: 24px;
          padding-top: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .icon {
            @include color_main();
            font-size: 18px;
            margin-right: 8px;
            float: left;
          }
        }
      }
      .section {
        flex: 1;
        background-color: #ffffff;
        margin-left: 220px;
        padding: 24px 24px 60px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        .footer {
          position: absolute;
          box-shadow: 0px -1px 0px 0px rgba(238, 242, 248, 1);
          left: 220px;
          right: 0;
          bottom: 0;
          height: 60px;
          z-index: 999;
          padding-top: 16px;
          padding-left: 24px;
          background-color: #ffffff;
        }
      }
    }
  }
}
</style>
